/* ==========================================================================
   Bhagwati Designer — product page behaviour.
   Variant picker, media gallery / lightbox, sticky add-to-cart.
   Loaded on the product template only. Registers on window.BhagwatiTheme.
   ========================================================================== */
(function () {
  'use strict';
  if (!window.BhagwatiTheme) return;

  var theme = window.BhagwatiTheme;
  var $ = theme.$, $$ = theme.$$, Money = theme.Money;

  /* ---------------------------------------------------------------------
     Product form (variant picker)
     --------------------------------------------------------------------- */
  var ProductForm = {
    init: function () {
      var form = $('[data-product-form]');
      if (!form) return;
      this.form = form;
      // the variant JSON lives in the product section, outside the <form>
      var jsonEl = document.querySelector('[data-variant-json]');
      try { this.json = jsonEl ? JSON.parse(jsonEl.textContent) : []; } catch (e) { this.json = []; }
      this.selectors = $$('[data-option-position]', form);
      this.idInput = $('[name="id"]', form);
      var self = this;
      form.addEventListener('change', function () { self.onChange(); });
      this.onChange(true);
    },

    getOptions: function () {
      var options = [];
      this.selectors.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        options.push(checked ? checked.value : '');
      });
      return options;
    },

    onChange: function (silent) {
      var options = this.getOptions();
      var match = null;
      this.json.forEach(function (v) {
        var vOpts = [v.option1, v.option2, v.option3].slice(0, options.length);
        if (vOpts.join(' / ') === options.join(' / ')) match = v;
      });

      // Update labels
      this.selectors.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var label = group.querySelector('[data-option-value]');
        if (label && checked) label.textContent = checked.value;
        $$('input', group).forEach(function (input) {
          var opt = input.getAttribute('data-value');
          var otherOptions = options.slice();
          otherOptions[parseInt(group.getAttribute('data-option-position'), 10) - 1] = opt;
          var available = this.json ? this.json.some(function (v) {
            var vOpts = [v.option1, v.option2, v.option3].slice(0, otherOptions.length);
            return vOpts.join(' / ') === otherOptions.join(' / ') && v.available;
          }) : true;
          input.closest('.swatch-option').classList.toggle('swatch-option--disabled', !available);
        }, this);
      }, this);

      if (this.idInput && match) this.idInput.value = match.id;

      if (match && !silent) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
        $$('[data-variant-price]').forEach(function (el) {
          if (match.price !== undefined) el.textContent = Money.format(match.price);
        });
        $$('[data-variant-compare]').forEach(function (el) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            el.textContent = Money.format(match.compare_at_price);
            el.style.display = '';
          } else { el.style.display = 'none'; }
        });
        var media = $('[data-variant-media="' + match.featured_media_id + '"]');
        if (media) Gallery.goTo(media.getAttribute('data-media-index'));
      }

      // keep the sticky bar in sync with the chosen variant
      var stickyBtn = $('.js-sticky-add');
      if (stickyBtn && match) {
        stickyBtn.setAttribute('data-variant-id', match.id);
        stickyBtn.disabled = !match.available;
        stickyBtn.textContent = match.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      }

      var submit = $('[data-add-button]', this.form);
      if (submit) {
        var available = match ? match.available : true;
        submit.disabled = !available;
        var textEl = submit.querySelector('[data-add-text]');
        if (textEl) {
          textEl.textContent = !match ? window.themeStrings.unavailable
            : (available ? window.themeStrings.addToCart : window.themeStrings.soldOut);
        }
      }
      var stock = $('[data-stock]');
      if (stock && match) {
        stock.classList.remove('product__stock--in', 'product__stock--out', 'product__stock--low');
        if (!match.available) { stock.className = 'product__stock product__stock--out'; stock.textContent = window.themeStrings.soldOut; }
        else if (match.inventory_management === 'shopify' && match.inventory_quantity > 0 && match.inventory_quantity <= 4) {
          stock.className = 'product__stock product__stock--low';
          stock.textContent = window.themeStrings.lowStock.replace('__COUNT__', match.inventory_quantity);
        } else { stock.className = 'product__stock product__stock--in'; stock.textContent = window.themeStrings.inStock; }
      }
    }
  };

  /* ---------------------------------------------------------------------
     Product gallery + lightbox
     --------------------------------------------------------------------- */
  var Gallery = {
    init: function () {
      var thumbs = $$('.product__thumb[data-media-index]');
      if (!thumbs.length) return;
      var self = this;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          self.goTo(t.getAttribute('data-media-index'));
        });
      });
      var stage = $('.product__stage');
      if (stage && !stage.dataset.zoomBound) {
        stage.dataset.zoomBound = '1';
        stage.addEventListener('click', function (e) {
          var img = e.target.closest('.zoomable');
          if (!img) return;
          var lb = $('#Lightbox');
          if (!lb) return;
          lb.querySelector('img').src = img.getAttribute('data-zoom') || img.src;
          lb.classList.add('is-open');
          document.body.classList.add('no-scroll');
        });
      }
    },
    goTo: function (index) {
      if (index === null || index === undefined) return;
      $$('.product__slide').forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-media-index') === String(index));
      });
      $$('.product__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-index') === String(index));
      });
    }
  };

  /* ---------------------------------------------------------------------
     Sticky add-to-cart
     --------------------------------------------------------------------- */
  var StickyAtc = {
    init: function () {
      var bar = $('.sticky-atc');
      var trigger = $('[data-add-button]');
      if (!bar || !trigger) return;
      var observed = trigger.closest('.product__form-block') || trigger;
      if (!('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(observed);
      var submit = bar.querySelector('.js-sticky-add');
      if (submit && !submit.dataset.bound) {
        submit.dataset.bound = '1';
        submit.addEventListener('click', function (e) {
          e.preventDefault();
          var id = submit.getAttribute('data-variant-id');
          var qtyInput = $('.product__form-block .qty__input') || $('.qty__input');
          theme.Cart.add(id, qtyInput ? qtyInput.value : 1, submit);
        });
      }
    }
  };

  theme.ProductForm = ProductForm;
  theme.Gallery = Gallery;
  theme.StickyAtc = StickyAtc;
  theme.register('product-form', ProductForm, { rebind: true });
  theme.register('gallery', Gallery, { rebind: true });
  theme.register('sticky-atc', StickyAtc, { rebind: true });
})();
